import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export const LandingsListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/banner_admin.filters.search")}
        />
      </Grid>
    </Grid>
  );
});
